module.exports = new __parcel__URL__("shop_machines_plasma_mortar.677623fd.png").toString();